import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import dayjs from "dayjs";
import "dayjs/locale/fr"; // Pour la langue française
import customParseFormat from "dayjs/plugin/customParseFormat";
import React from "react";
import Tab from "@mui/material/Tab";
import ContainedTabs from "../Tabs/ContainedTabs";
import GridListProductCard from "../../components/Cards/ProductCard/GridListProductCard";
import Paper from "@mui/material/Paper";
import ButtonMenuSettings from "../Button/ButtonMenuSettings";
import { useData } from "../../lib/context/DataContext";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
dayjs.extend(customParseFormat);
dayjs.locale("fr");

export default function VentePaper({ vente, hideCommandes }) {
	const jourOuverture = vente
		? dayjs(vente.debutVente, "DD-MM").format("dddd D MMMM")
		: null;
	const jourLivraison = vente
		? dayjs(vente.livraisonVente, "DD-MM").format("dddd D MMMM")
		: null;
	const jourFermeture = vente
		? dayjs(vente.finVente, "DD-MM")
				.subtract(1, "day")
				.format("dddd D MMMM")
		: null;

	const [selectedTab, setSelectedTab] = React.useState("produits");

	const { commandeEnCours, produits } = useData();
	const [commandeClient, setCommandeClient] = React.useState(null);

	const sortingCommandeClient = React.useCallback(async () => {
		if (!commandeClient && commandeEnCours && !hideCommandes) {
			setCommandeClient([]);

			Object.entries(commandeEnCours).forEach(([key, value]) => {
				if (
					key !== "etag" &&
					key !== "partitionKey" &&
					key !== "rowKey" &&
					key !== "timestamp" &&
					key !== "open"
				) {
					return setCommandeClient((prev) => [
						...prev,
						{
							client: key,
							produits: value,
						},
					]);
				}
			});
		}
	}, [commandeEnCours, commandeClient, hideCommandes]);

	React.useEffect(() => {
		sortingCommandeClient();
	}, [sortingCommandeClient]);

	const sortingProduit = (id) => {
		return produits.data.filter((item) => item.rowKey === id)[0];
	};

	const clients = [{ id: "amoisant", name: "A.Moisant" }];

	const sortingClients = (id) => {
		return clients.filter((item) => item.id === id)[0].name;
	};

	if (vente)
		return (
			<Stack
				spacing={1}
				component={Paper}
				variant="outlined"
				p={1}
			>
				<Alert
					severity="info"
					color="secondary"
					sx={{
						alignItems: "center",

						"& .MuiAlert-icon": {
							fontSize: 40,
						},
						"& .MuiAlert-message": {
							width: "100%",
						},
					}}
				>
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
					>
						<AlertTitle
							variant="h6"
							sx={{ fontWeight: "600" }}
						>
							Vente{" "}
							{vente.rowKey
								.replace("Vente-", "")
								.replace("-2025", "")
								.replace("-", " ")}
						</AlertTitle>
						<ButtonMenuSettings
							type={"vente"}
							id={vente.rowKey}
						/>
					</Stack>

					<Typography>
						La vente est ouverte depuis <b>{jourOuverture}</b> à{" "}
						<b>9h</b>
						<br />
						La vente fermera le <b>{jourFermeture}</b> à <b>10h</b>
						<br />
						Les produits pourront être récupérés le{" "}
						<b>{jourLivraison}</b>
					</Typography>
				</Alert>
				<ContainedTabs
					value={selectedTab}
					indicatorColor="secondary"
					onChange={(e, v) => setSelectedTab(v)}
				>
					<Tab
						label={"produits en vente"}
						value={"produits"}
					/>
					{!hideCommandes && (
						<Tab
							label={"commandes client"}
							value={"commandes"}
						/>
					)}
				</ContainedTabs>
				{selectedTab === "produits" && (
					<GridListProductCard
						products={JSON.parse(vente.produitsEnVente)}
						type={"showroom"}
					/>
				)}
				{selectedTab === "commandes" &&
					(!commandeClient ? (
						<Skeleton
							variant="rounded"
							height={100}
						/>
					) : (
						<Stack spacing={2}>
							{commandeClient.map((item) => (
								<Paper
									variant="outlined"
									key={item.client}
									sx={{ p: 2 }}
								>
									<Typography variant="h5">
										{sortingClients(item.client)}
									</Typography>
									<Divider sx={{ my: 1 }} />
									<Stack
										spacing={1}
										divider={<Divider />}
									>
										{JSON.parse(item.produits).map((p) => (
											<Stack
												direction="row"
												key={p.produit}
												justifyContent="space-between"
											>
												<Typography>
													{
														sortingProduit(
															p.produit
														).name
													}
												</Typography>
												<Typography>
													{sortingProduit(p.produit)
														.unite === "Kg"
														? Number(
																p.quantite
														  ).toFixed(3) +
														  " " +
														  sortingProduit(
																p.produit
														  ).unite
														: p.quantite +
														  " " +
														  sortingProduit(
																p.produit
														  ).unite}
												</Typography>
											</Stack>
										))}
									</Stack>
								</Paper>
							))}
						</Stack>
					))}
			</Stack>
		);
}
